import { customerBaseApi } from "@/react/services/api/api";

import { PROFILE } from "../constants";
import { tenantProfilePath } from "../urls";

const profileApi = customerBaseApi.injectEndpoints({
  endpoints: (build) => ({
    getProfile: build.query({
      query: (tenantName) => ({
        url: tenantProfilePath(tenantName),
        method: "GET",
      }),
      providesTags: [PROFILE],
    }),
  }),
});

export const { useGetProfileQuery } = profileApi;
